/**
 * anim--char-fade
 * .anim--char-fade クラスを持つ要素のテキストを
 * 1文字ずつ span.char に分割し、stagger アニメーションを適用する
 *
 * オプション（data属性で上書き可能）:
 *   data-delay="0.06"   → 各文字の遅延間隔（秒）デフォルト: 0.06
 *   data-duration="0.4" → 各文字のアニメーション時間（秒）デフォルト: 0.4
 */

function initCharFade(el) {
	el.style.opacity = '1'; // 親要素を表示（CSS側で初期 opacity:0 にしておく）

	const delay = parseFloat(el.dataset.delay || 0.08);
	const duration = parseFloat(el.dataset.duration || 0.8);

	const text = el.dataset.original ? el.dataset.original : el.textContent.trim();
	el.dataset.original = text;

	el.innerHTML = [...text].map((ch, i) => {
		if (ch === ' ') {
			return `<span class="char char--space">&nbsp;</span>`;
		}
		const d = (i * delay).toFixed(3);
		return `<span class="char" style="animation-delay:${d}s;animation-duration:${duration}s">${ch}</span>`;
	}).join('');
}

// 初期化済みフラグ
let charFadeInitialized = false;

document.addEventListener('loadingComplete', function () {
	// 2回目以降は無視
	if (charFadeInitialized) return;
	charFadeInitialized = true;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				initCharFade(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.1
	});

	document.querySelectorAll('.anim--char-fade').forEach(el => observer.observe(el));
});
